import { cva } from 'class-variance-authority';

export const getCtaStyles = cva('fs-cta', {
	variants: {
		intent: {
			filled: [
				'bg-button-primary',
				'text-button-primary-inverse',
				'border-button-primary',
				'hover:bg-button-primary-hover',
				'hover:border-button-primary-hover',
				'focus:bg-button-primary-hover',
				'focus:border-button-primary-hover',

				'active:bg-button-primary-pressed',
				'active:border-button-primary-pressed',
				'active:text-button-primary-inverse',

				'disabled:bg-button-primary-disabled',
				'disabled:border-button-primary-disabled',
				'disabled:text-button-primary-disabled-inverse',
				'disabled:cursor-not-allowed',
			],
			outline: [
				'text-button-primary',
				'border-button-primary',
				'hover:bg-button-primary-ghost-hover',
				'hover:border-button-primary-hover',
				'hover:text-button-primary-hover',
				'focus:bg-button-primary-ghost-hover',
				'focus:border-button-primary-hover',
				'focus:text-button-primary-hover',

				'active:bg-button-primary-ghost-pressed',
				'active:border-button-primary-pressed',
				'active:text-button-primary-pressed',

				'disabled:bg-transparent',
				'disabled:hover:bg-transparent',
				'disabled:text-button-primary-disabled',
				'disabled:border-button-primary-disabled',
			],
			ghost: [
				'text-button-primary',
				'border-transparent',
				'hover:bg-button-primary-ghost-hover',
				'hover:text-button-primary-hover',
				'focus:bg-button-primary-ghost-hover',
				'focus:text-button-primary-hover',
				'active:bg-button-primary-ghost-pressed',
				'active:text-button-primary-ghost-pressed',
				'disabled:bg-transparent',
				'disabled:hover:bg-transparent',
				'disabled:text-button-primary-disabled',
			],
			text: [
				'text-button-primary',
				'hover:text-button-primary-hover',
				'focus:text-button-primary-hover',
				'active:text-button-primary-pressed',
				'disabled:text-button-primary-disabled',
				'transition-colors',
			],
			unstyled: [],
		},
		isLoading: {
			true: ['cursor-wait'],
			false: [],
		},
		hasIcon: {
			true: ['flex', 'flex-row', 'gap-150', 'items-center'],
			false: [],
		},
		size: {
			small: [],
			medium: [],
		},
		iconPosition: {
			start: ['flex-row-reverse'],
			end: [],
		},
		inverse: {
			true: [],
			false: [],
		},
	},
	compoundVariants: [
		{
			intent: ['filled', 'outline', 'ghost', 'text'],
			className: [
				'uppercase',
				'inline-flex',
				'flex-row',
				'gap-150',
				'items-center',
				'justify-center',
				'cursor-pointer',
				'disabled:cursor-not-allowed',
			],
		},
		{
			intent: ['filled', 'outline', 'ghost', 'text'],
			size: ['medium'],
			className: ['text-button1'],
		},
		{
			intent: ['filled', 'outline', 'ghost', 'text'],
			size: ['small'],
			className: ['text-button2'],
		},
		{
			intent: ['filled', 'outline', 'ghost'],
			className: ['border', 'py-100', 'px-200', 'rounded', 'h-400'],
		},
		{
			intent: ['text'],
			hasIcon: [false],
			className: ['border-b', 'border-inherit'],
		},
		{
			intent: ['text'],
			inverse: [true],
			className: ['text-button-primary-inverse'],
		},
	],
	defaultVariants: {
		intent: 'filled',
		isLoading: false,
		iconPosition: 'end',
		size: 'small',
		inverse: false,
	},
});

export default getCtaStyles;
